module.exports = __webpack_public_path__ + "static/img/wdsjtb1-4.aec47c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdsjtb1-4.png
// module id = 873
// module chunks = 0